import React from 'react';
import { Heart } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const Footer = () => {
  const { pathname } = useLocation();
  const anchor = (id) => (pathname === '/' ? `#${id}` : `/#${id}`);
  return (
  <footer id="contact" data-testid="footer">
    <div className="container">
      <div className="footergrid">
        <div>
          <div className="footerlogo"><Heart size={24} fill="#fff" /> Krysha</div>
          <p>A Love Station With Your Vibe.</p>
          <p>Compatibility-first matchmaking for people who are done with endless swiping. One form, human-reviewed matches, details sent straight to you.</p>
        </div>
        <div>
          <b>Explore</b>
          <a href={anchor('about')} data-testid="footer-about-link">About Us</a>
          <a href={anchor('how')} data-testid="footer-how-link">How It Works</a>
          <a href={anchor('faq')} data-testid="footer-faq-link">FAQ</a>
          <a href={anchor('match')} data-testid="footer-match-link">Get My Match</a>
        </div>
        <div>
          <b>Matchmaking</b>
          <a href={anchor('match')} data-testid="footer-plans-link">Plans</a>
          <a href={anchor('stories')} data-testid="footer-testimonials-link">Testimonials</a>
          <a href={anchor('why')} data-testid="footer-why-link">Why Krysha</a>
        </div>
        <div>
          <b>Reach Us</b>
          <p>hello@krysha.love</p>
          <p>WhatsApp support</p>
          <p>@krysha.love on Instagram</p>
        </div>
      </div>
      <div className="footer-bottom">
        © {new Date().getFullYear()} Krysha — A Love Station With Your Vibe. All rights reserved. · Formerly Soulmate Matchmaking · <Link to="/terms" data-testid="footer-terms-link" style={{ color: 'inherit', textDecoration: 'underline' }}>Terms &amp; Refund Policy</Link> · <Link to="/admin" data-testid="footer-admin-link" style={{ color: 'inherit', textDecoration: 'underline' }}>Admin</Link>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
